import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function SingleVerticalEnergy() {
  return (
    <div className="single-vertical-parent">
      <div className="vertical-title">
        <div className="text-900 font-bold text-7xl mb-4 text-center">
          FlexNet Energy: Powering the Future with Smart Connectivity
        </div>
        <div className="text-700 text-xl mb-6 text-center line-height-3">
          Enhance grid reliability, optimize energy distribution, and improve
          asset management with advanced 4G/5G-enabled solutions.
        </div>
      </div>
      {/* Hero Section */}
      <div className="grid grid-nogutter surface-section text-800 ">
        <div className="col-12 md:col-6 p-6 text-center md:text-left flex align-items-center">
          <section>
            <span className="block text-6xl font-bold mb-3">FlexNet Port</span>
            <div className="text-6xl text-primary font-bold mb-3">
              Revolutionizing Operations with 5G Connectivity
            </div>
            <p className="mt-0 mb-4 text-700 line-height-3">
              Revolutionize the energy sector with FlexNet Energy. Our robust
              4G/5G connectivity ensures real-time monitoring, efficient energy
              distribution, predictive maintenance, and enhanced grid security
              for modern energy infrastructures.
            </p>
            <button className="flex underline align-items-center mt-4">
              <Link to="/connectivity">Request Demo</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </section>
        </div>
        <div className="col-12 md:col-6 overflow-hidden">
          <img
            src="https://commtelnetworks.com/wp-content/uploads/elementor/thumbs/Smart-Grids-banner-plk6lezt7l5g8rbmnh65kr31j52rmhlmnsohpnj1c8.jpg"
            alt="hero-1"
            className="md:ml-auto block md:h-full"
            style={{ clipPath: "polygon(8% 0, 100% 0%, 100% 100%, 0 100%)" }}
          />
        </div>
      </div>

      {/* Key Benefits Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-900">Why </span>
          <span className="text-blue-600">Choose FlexNet Energy?</span>
        </div>
        <div className="grid justify-center">
          {keyBenefits.map((benefit, index) => (
            <div key={index} className="col-12 md:col-4 mb-4 px-5">
              <span
                className="p-3 shadow-2 mb-3 inline-block surface-card"
                style={{ borderRadius: "10px" }}
              >
                <i className={`${benefit.icon} text-4xl text-blue-500`}></i>
              </span>
              <div className="text-900 text-xl mb-3 font-medium">
                {benefit.title}
              </div>
              <span className="text-700 line-height-3">{benefit.detail}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Use Cases Section */}

      <div className="mb-3 font-bold text-3xl">
        <span className="text-900">FlexNet Energy </span>
        <span className="text-blue-600">Use Cases</span>
      </div>
      {useCases.map((useCase, index) => (
        <div
          key={index}
          className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center"
        >
          <div className="b-3 font-bold text-2xl mb-3">
            <span className="text-blue-600">Use Case</span>
            {useCase.title}
          </div>
          <div className="text-700 mb-6">{useCase.description}</div>
          <div className="grid">
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">Benefits</div>
              {useCase.benefits.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Devices/Technologies
              </div>
              {useCase.devices.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <div className="col-12 md:col-4 mb-4 px-5">
              <div className="text-900 text-xl mb-3 font-medium">
                Applications
              </div>
              {useCase.applications.map((item, idx) => (
                <div key={idx} className="mb-2">
                  <i className={`${item.icon} text-blue-500 mr-2`}></i>
                  {item.title}
                </div>
              ))}
            </div>
            <button className="flex underline align-items-center mt-4 vertical-market-link">
              <Link to="/marketplace">Request Access to Marketplace</Link>
              <FaExternalLinkAlt className="ml-2" />
            </button>
          </div>
        </div>
      ))}

      {/* Case Studies Testimonias Section */}
      <div className="surface-section px-4 py-8 md:px-6 lg:px-8 text-center">
        <div className="mb-3 font-bold text-3xl">
          <span className="text-blue-600"> Key Technical Features</span>
        </div>
        <div className="grid justify-center">
          <div className="text-900 text-xl mb-3 font-medium"></div>
          <div className="technical-specifications">
            <div className="text-700 line-height-3 technical-specifications-box text-xl">
              <ul className="list-disc pl-5 mt-3">
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  High-speed, low-latency 4G/5G connectivity
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Edge computing for real-time data processing
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Secure data transmission with advanced encryption protocols
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Seamless integration with existing energy management systems
                </li>
                <li className="before:content-['\2022'] before:mr-2 before:text-blue-600">
                  Scalable solutions for diverse energy environments
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Call-to-Action Section */}
      <div className="surface-section text-center py-8">
        <div className="text-900 text-3xl font-bold mb-4">
          Ready to Optimize Your Energy Operations?
        </div>

        <button className="p-button p-button-raised connectivity-request-demo-button p-3">
          <Link to="contact-page">Get in Touch for a Personalized Demo</Link>
        </button>
      </div>
    </div>
  );
}

const keyBenefits = [
  {
    title: "Real-Time Grid Monitoring and Control",
    detail: "Ensure stable energy distribution with IoT-enabled monitoring.",
    icon: "pi pi-chart-bar",
  },
  {
    title: "Enhanced Efficiency for Renewable Energy Integration",
    detail:
      "Optimize energy generation from renewable sources with smart connectivity.",
    icon: "pi pi-bolt ",
  },
  {
    title: "Predictive Maintenance for Critical Infrastructure",
    detail:
      "Reduce downtime and extend equipment lifespan through proactive monitoring.",
    icon: "pi pi-chart-line",
  },
  {
    title: "Improved Energy Asset Management",
    detail: "Enhance operational efficiency with data-driven insights.",
    icon: "pi  pi-chart-bar",
  },
  {
    title: "Secure, High-Speed 4G/5G Connectivity for Remote Sites",
    detail: "Ensure reliable and secure communication in energy facilities.",
    icon: "pi pi-wifi",
  },
];

const useCases = [
  {
    title: "1: Smart Grid Monitoring and Management",
    description:
      "Deploy IoT-enabled sensors with 4G/5G connectivity for real-time monitoring of grid operations, ensuring stable energy distribution.",
    benefits: [
      {
        title: "Improve grid reliability and reduce outages",
        icon: "pi pi-bolt",
      },
      {
        title: "Optimize energy flow with real-time data",
        icon: "pi pi-chart-line ",
      },
      {
        title: "Enhance fault detection and response times",
        icon: "pi pi-exclamation-triangle",
      },
    ],
    devices: [
      { title: "Smart Meters", icon: "pi pi-microchip" },
      { title: "IoT Sensors", icon: "pi pi-cloud" },
      { title: "4G/5G Gateways", icon: "pi pi-wifi" },
    ],
    applications: [
      { title: "Utility Grids", icon: "pi pi-globe" },
      { title: "Substation Monitoring", icon: "pi pi-server" },
      { title: "Power Distribution Networks", icon: "pi pi-sitemap" },
    ],
  },
  {
    title: "2: Renewable Energy Integration and Monitoring",
    description:
      "Use 4G/5G networks to connect wind farms, solar panels, and energy storage systems for seamless integration into the grid.",
    benefits: [
      {
        title: "Optimize energy generation from renewable sources",
        icon: "pi pi-chart-bar",
      },
      {
        title: "Real-time performance tracking and fault detection",
        icon: "pi pi-chart-line",
      },
      { title: "Improve energy storage management", icon: "pi pi-bolt" },
    ],
    devices: [
      { title: "Wind Turbine Sensors", icon: "pi pi-microchip" },
      { title: "Solar Inverters", icon: "pi pi-sun" },
      { title: "Energy Storage Systems", icon: "pi pi-database" },
    ],
    applications: [
      { title: "Wind Farms", icon: "pi pi-globe" },
      { title: "Solar Power Plants", icon: "pi pi-sun" },
      { title: "Battery Storage Facilities", icon: "pi pi-database" },
    ],
  },
  {
    title: "3: Predictive Maintenance for Energy Infrastructure",
    description:
      "Utilize predictive analytics powered by real-time data from connected devices to identify potential equipment failures before they occur.",
    benefits: [
      {
        title: "Reduce unplanned downtime and maintenance costs",
        icon: "pi pi-clock",
      },
      {
        title: "Extend the lifespan of critical infrastructure",
        icon: "pi pi-cog",
      },
      { title: "Improve operational efficiency", icon: "pi pi-chart-bar" },
    ],
    devices: [
      { title: "IoT Sensors", icon: "pi pi-cloud" },
      { title: "Predictive Analytics Platforms", icon: "pi pi-microchip" },
      { title: "4G/5G Connectivity", icon: "pi pi-wifi" },
    ],
    applications: [
      { title: "Power Plants", icon: "pi pi-globe" },
      { title: "Transmission Lines", icon: "pi pi-link" },
      { title: "Energy Distribution Equipment", icon: "pi pi-sitemap" },
    ],
  },
  {
    title: "4: Remote Asset Monitoring and Control",
    description:
      "Enable secure, real-time monitoring and remote control of energy assets in hard-to-reach or hazardous environments using 4G/5G networks.",
    benefits: [
      { title: "Reduce the need for on-site inspections", icon: "pi pi-eye" },
      { title: "Improve safety for field personnel", icon: "pi pi-shield" },
      {
        title: "Enhance operational efficiency with remote diagnostics",
        icon: "pi pi-cog",
      },
    ],
    devices: [
      { title: "Remote Terminal Units (RTUs)", icon: "pi pi-server" },
      { title: "IoT Gateways", icon: "pi pi-cloud" },
      { title: "Secure Communication Modules", icon: "pi pi-lock" },
    ],
    applications: [
      { title: "Oil & Gas Fields", icon: "pi pi-globe" },
      { title: "Remote Power Stations", icon: "pi pi-bolt" },
      { title: "Utility Infrastructure", icon: "pi pi-sitemap" },
    ],
  },
  {
    title: "5: Drone Inspection of Solar and Wind Panels",
    description:
      "Utilize 4G/5G-connected drones for real-time inspection and monitoring of solar panels and wind turbines, ensuring efficient maintenance and early detection of faults.",
    benefits: [
      { title: "Reduce inspection costs and time", icon: "pi pi-clock" },
      {
        title:
          "Enhance safety by minimizing the need for manual inspections in hazardous areas",
        icon: "pi pi-shield",
      },
      {
        title:
          "Improve efficiency with high-resolution imaging and real-time data analysis",
        icon: "pi pi-camera",
      },
    ],
    devices: [
      { title: "Drones with 4G/5G Connectivity", icon: "pi pi-send" },
      { title: "High-Resolution Cameras", icon: "pi pi-camera" },
      { title: "Thermal Imaging Sensors", icon: "pi pi-microchip" },
    ],
    applications: [
      { title: "Solar Farms", icon: "pi pi-sun" },
      { title: "Wind Turbine Installations", icon: "pi pi-microchip" },
      { title: "Renewable Energy Sites", icon: "pi pi-globe" },
    ],
  },
];
